import MemberList from './member_list.vue'

export default {
    path: 'memberList',
    component: MemberList
}
